import { gql } from '@apollo/client';

export default gql`
  mutation storePaymentMethodMutation($input: PaymentMethodInput!) {
    storePaymentMethod(input: $input) {
      id
      token
      primary
      code
      status
    }
  }
`;
